// src/pages/Dashboard/teacher/paperEvaluation/paperEvaluationHelpers.js

export const BACKEND_URL =
  process.env.REACT_APP_VOICE_TO_VOICE_URL;
export const WS_URL = BACKEND_URL.replace(/^http/, "ws");


if (!BACKEND_URL || !WS_URL) {
  console.error("Paper Evaluation env vars missing");
}


// Call backend to generate S3 presigned URLs
export async function generateUploadUrls({
  sessionId,
  teacherId,
  studentId,
  subject,
  sections,
}) {
  const structure = sections.map((section) => ({
    section_type: section.section_type,
    questions: section.questions.map((q) => ({
      question_id: q.question_id,
      file_count: q.files.length,
    })),
  }));

  const res = await fetch(`${BACKEND_URL}/api/generate-upload-urls`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      session_id: sessionId,
      teacher_id: teacherId,
      student_id: studentId,
      subject: subject,
      structure: structure,
    }),
  });

  console.log("res from ppr evalution",res)

  if (!res.ok) {
    const text = await res.text();
    console.error("generate-upload-urls error:", text);
    throw new Error("Failed to generate upload URLs");
  }

  return res.json();
}

// Stitch OCR text for a specific section & question
export function stitchOCRText(ocrResults, sectionType, questionId) {
  if (!ocrResults || ocrResults.length === 0) return "";

  const filtered = ocrResults
    .filter(
      (r) => r.section === sectionType && r.question_id === questionId
    )
    .sort((a, b) => (a.page_index ?? 0) - (b.page_index ?? 0));

  return filtered.map((f) => f.text || "").join("\n\n");
}

// Call evaluation API
export async function evaluateAnswerApi(payload) {
  const res = await fetch(`${BACKEND_URL}/evaluate-answer`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    const text = await res.text();
    console.error("evaluate-answer error:", text);
    throw new Error("Failed to evaluate answer");
  }

  return res.json();
}

